// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__hvA+j","active":"Navigation_active__kVSfR"};